import { useState, useEffect, useRef } from "react";
import Label from "../Label";
import { ApprovedSign, DownArrowIcon } from "../Icons";

const Dropdown = ({
  options = [],
  value,
  onChange,
  label,
  id,
  name,
  placeholder = "Select",
  disabled = false,
  readOnly = false,
  error,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const isLocked = disabled || readOnly;

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleToggle = () => {
    if (isLocked) return;
    setIsOpen((prev) => !prev);
  };

  const handleSelect = (option) => {
    if (isLocked) return;

    onChange({ target: { value: option.value, name } });
    setIsOpen(false);
  };

  const getDisplayLabel = () => {
    const selectedOption = options.find((option) => option.value === value);
    return selectedOption ? selectedOption.label : placeholder;
  };

  return (
    <div ref={dropdownRef} className={`dropdown-wrapper ${disabled ? "opacity-60 cursor-not-allowed" : ""}`}>
      <div
        onClick={handleToggle}
        className={`dropdown-control ${isLocked ? "form-input-field-wrapper-readonly cursor-not-allowed" : "cursor-pointer"} ${error ? "select-input-error" : ""}`}
      >
        <Label htmlFor={id} className="dropdown-label" text={label} />

        <div className="flex justify-between items-center">
          <span
            className={`dropdown-value ${
              value ? "dropdown-value-selected" : "dropdown-value-placeholder"
            }`}
          >
            {getDisplayLabel()}
          </span>

          <div className={`dropdown-arrow transition-transform ${isOpen ? "rotate-180" : ""}`}>
            <DownArrowIcon className="h-5 w-5" />
          </div>
        </div>
      </div>

      <div
        className={`dropdown-menu-wrapper ${
          isOpen
            ? "opacity-100 scale-100 pointer-events-auto"
            : "opacity-0 scale-95 pointer-events-none"
        }`}
      >
        {isOpen && !isLocked && (
          <ul className="dropdown-menu">
            {options.map((option) => (
              <li
                key={option.value}
                className={`dropdown-item ${
                  option.value === value
                    ? "dropdown-item-selected"
                    : "dropdown-item-hover"
                }`}
                onClick={() => handleSelect(option)}
              >
                <span>{option.label}</span>
                {option.value === value && <ApprovedSign />}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default Dropdown;